import routes, { AppRoute, NavSectionName } from "routes";

export type NavSection = {
  label: NavSectionName;
  items: AppRoute[];
};

// Display order of the sidebar / command-palette groups. Routes carry their
// own `section` field (required by the AppRoute type), so adding a route to
// routes.tsx is enough — there is no second registry to keep in sync.
const SECTION_ORDER: NavSectionName[] = [
  "Overview",
  "Devices",
  "Content",
  "Commerce",
  "Klydo App",
  "People",
];

export const NAV_SECTIONS: NavSection[] = SECTION_ORDER.map((label) => ({
  label,
  items: routes.filter((r) => r.section === label && !r.hideFromNav),
})).filter((section) => section.items.length > 0);

export const findRouteByPath = (pathname: string): AppRoute | undefined =>
  routes.find((r) => pathname.startsWith(r.layout + r.path));

export const findSectionForRoute = (
  route: AppRoute | undefined,
): NavSection | undefined =>
  route && NAV_SECTIONS.find((s) => s.items.includes(route));
